var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDefaultFontActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_30485",
    "data-name": "Group 30485",
    transform: "translate(10704 -17338)"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_14180",
    "data-name": "Rectangle 14180",
    width: 32,
    height: 32,
    transform: "translate(-10704 17338)",
    fill: "none"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30609",
    "data-name": "Group 30609",
    transform: "translate(-7744.467 14851.623)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_30611",
    "data-name": "Group 30611",
    transform: "translate(-2953.534 2494.378)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50113",
    "data-name": "Path 50113",
    d: "M340.6,58.631h-6.466a1.727,1.727,0,1,1,0-3.44h1.345V46.313h-2.584V47.3a1.9,1.9,0,0,1-3.778,0v-2.7A1.813,1.813,0,0,1,331,42.873h12.722a1.812,1.812,0,0,1,1.889,1.72v2.7a1.9,1.9,0,0,1-3.778,0v-.983h-2.582v8.878H340.6a1.727,1.727,0,1,1,0,3.44Zm-6.466-2.64a.924.924,0,1,0,0,1.839H340.6a.924.924,0,1,0,0-1.839h-1.782a.421.421,0,0,1-.439-.4V45.913a.421.421,0,0,1,.439-.4h3.46a.421.421,0,0,1,.439.4V47.3a1.015,1.015,0,0,0,2.021,0v-2.7a.969.969,0,0,0-1.01-.92H331a.969.969,0,0,0-1.011.92v2.7a1.015,1.015,0,0,0,2.021,0V45.913a.421.421,0,0,1,.439-.4h3.462a.421.421,0,0,1,.439.4v9.678a.421.421,0,0,1-.439.4Z",
    transform: "translate(-325.614 -42.873)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("g", {
    id: "Group_30611-2",
    "data-name": "Group 30611",
    transform: "translate(0 9.679)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_50114",
    "data-name": "Path 50114",
    d: "M322.688,61a.281.281,0,0,1-.281-.281V59.9h-4.252v.814a.281.281,0,1,1-.562,0v-1.1a.281.281,0,0,1,.281-.281h4.814a.281.281,0,0,1,.281.281v1.1A.281.281,0,0,1,322.688,61Z",
    transform: "translate(-317.593 -59.339)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50115",
    "data-name": "Path 50115",
    d: "M325.8,65.418a.281.281,0,0,1-.281-.281V59.62a.281.281,0,0,1,.563,0v5.516A.281.281,0,0,1,325.8,65.418Z",
    transform: "translate(-323.109 -59.339)",
    stroke: "#000",
    strokeWidth: 0.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_50116",
    "data-name": "Path 50116",
    d: "M324.273,78.06h-2.358a.281.281,0,0,1,0-.563h2.358a.281.281,0,1,1,0,.563Z",
    transform: "translate(-320.406 -71.981)",
    stroke: "#000",
    strokeWidth: 0.5
  })))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDefaultFontActive);
export default __webpack_public_path__ + "static/media/defaultFontActive.7e680323.svg";
export { ForwardRef as ReactComponent };